<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data
    [title]="'Generate GB Prelims'"
    [lotNumber]="_appGeneralState.currentLotNumber"
    [lotName]="_appGeneralState.currentLotName"
></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onGeneratePrelims()" 
                novalidate
                [formGroup]="invoiceCreateForm" 
                style="margin-top:20px;">
                <div class="row" style="width:100%;">
                 <div class="col-3">
                    <mat-form-field appearance="fill" style="width:100%">
                        <mat-label>Revenue Date</mat-label>
                        <input matInput placeholder="Revenue Date"  autocomplete="chrome-off" maxlength="32" formControlName="revenueDate" readonly>
                      </mat-form-field>
                </div>
                @if(invoiceCreateForm?.get('multiMonthInvoice')?.value == false){
                 <div class="col-3">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Invoice Date</mat-label>
                        <input matInput placeholder="Invoice Date"  autocomplete="chrome-off" maxlength="32" formControlName="invoiceDate" readonly>
                     </mat-form-field>
                </div>
                }

                @if(invoiceCreateForm?.get('multiMonthInvoice')?.value == true){
                   <div class="col-3">
                        <mat-form-field appearance="fill" style="width:100%;color:gray">
                            <mat-label>Number of Months</mat-label>
                            <mat-select formControlName="multiMonthCount">
                                <mat-option [value]="1">1</mat-option>
                                <mat-option [value]="2">2</mat-option>
                                <mat-option [value]="3">3</mat-option>
                                <mat-option [value]="4">4</mat-option>
                                <mat-option [value]="5">5</mat-option>
                                <mat-option [value]="6">6</mat-option>
                                <mat-option [value]="7">7</mat-option>
                                <mat-option [value]="8">8</mat-option>
                                <mat-option [value]="9">9</mat-option>
                                <mat-option [value]="10">10</mat-option>
                                <mat-option [value]="11">11</mat-option>
                                <mat-option [value]="12">12</mat-option>
                            </mat-select>
                         </mat-form-field>
                    </div>
                }
             

                </div>

                <div class="row" style="width:100%;">
                 <div class="col-3">
                  <p><mat-checkbox formControlName="currentMonthOnly">Current Month Only</mat-checkbox></p>
                </div>
                 <div class="col-3">
                    <p><mat-checkbox formControlName="multiMonthInvoice">Generate Multi-Month Invoice</mat-checkbox></p>
                </div>

                @if(invoiceCreateForm?.get('multiMonthInvoice')?.value == true){
                    <div class="col-3">
                        <p><mat-checkbox formControlName="createPastInvoices">Create Past Invoice(s)</mat-checkbox></p>
                    </div>
                }

                 @if(invoiceCreateForm?.get('multiMonthInvoice')?.value == true){
                    <div class="col-6">
                        <mat-selection-list formControlName="companies" [multiple]="false" hideSingleSelectionIndicator style="height:200px;overflow-y:auto;width:90%;overflow-x: hidden;border:1px solid #333;">
                            <mat-list-option [value]="">Select Company</mat-list-option>
                            <mat-list-option [value]="'A'">Company A</mat-list-option>
                            <mat-list-option [value]="'B'">Company B</mat-list-option>
                        </mat-selection-list>
                    </div>
                }
                </div>
            
            <!-- <div class="row" style="width:100%;margin-top:2px;"> -->
                <div class="col-3">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;" [disabled]="!invoiceCreateForm.valid">Generate Prelims</button>
                    <!-- <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onClearSearchCriteria()">Clear</button> -->
                </div>    
            <!-- </div> -->
            <!-- </div> -->
        </form>

        <ng-container *ngIf="queryInProcess">
            <div class="row mt-3" >
                <div class="col-12 text-center">
                    <span><strong>Creating Preliminary Invoices.  This may take a few minutes.</strong></span><br />
                    <strong><span style="color:#003087">{{currentStep}}</span></strong>
                </div>
            </div>
            <div style="margin-top:30px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                
            </div>
        </ng-container>

        <ng-container *ngIf="!queryCompleted && queryInProcess == false">
            <div style="margin-top:30px;margin-left:20px;">
                <strong>Click Generate Prelim Button to Create Preliminary GB Invoices </strong>
            </div>
        </ng-container>

        <ng-container *ngIf="queryCompleted && prelimInvoiceList.length == 0">
            <div style="margin-top:30px;margin-left:20px;">
                <strong>No prelim invoices have been generated</strong>
            </div>
        </ng-container>

        <ng-container *ngIf="this.prelimInvoiceList.length > 0">
           
            <hr  style="margin-top:20px;"/>
            
            
            <div class="row">
                <div class="col-2">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;margin-top:20px;margin-bottom:30px;" 
                        [disabled]="noInvoicesSelectedForFinalization"
                        (click)="onFinalizeSelectedInvoices()"
                        >Finalize Prelims
                    </button>
                </div>  
                    <!-- <div class="col-4">
                        <span *ngIf="!noInvoicesSelectedForFinalization">
                            {{prelimInvoiceList.length}} invoices selected to finalize
                        </span>
                    </div> -->
                </div>


                <div class="row" style="margin-top:20px;">
                    <div class="col-3">
                        Company Prelim Invoices: {{numberOfCompanyInvoices}}
                    </div>
                    <div class="col-3">
                        Parker Prelim Invoices: {{numberOfParkerInvoices}}
                    </div>
                    <div class="col-3">
                        Company Invoices Finalized: {{numberOfCompanyInvoicesFinalized}}
                    </div>
                    <div class="col-3">
                        Parker Invoices Finalized: {{numberOfParkerInvoicesFinalized}}
                    </div>
                </div>

                <mat-tab-group style="margin-top:30px;">
                    <mat-tab label="Invoice List">

            <mat-form-field style="margin-top:20px;width:100%">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Invoice Number" #input style="width:95%">
              </mat-form-field>
              
              <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              
                <ng-container matColumnDef="selection">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        <mat-checkbox (click)="onToggleSelectAll()">Select All</mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element;let i = index;"> 
                        @if(prelimInvoiceList[i].isPrelim){
                            <mat-checkbox (click)="onToggleFinalization(element.invoiceNumber)" [checked]="prelimInvoiceList[i].selectForFinalization"></mat-checkbox>
                        }
                        @else
                        {
                            <strong>Finalized</strong>
                        }

                        
                    </td>
                </ng-container>
              
                <ng-container matColumnDef="invoiceNumber">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Invoice Number
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        <a href="https://{{urlDomain}}/Invoice/ReturnPdf/{{_appGeneralState.currentLotNumber}}/{{element.invoiceNumber}}" target="_blank">
                            {{element.invoiceNumber}}
                        </a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="invoiceDate">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Revenue Date
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{element.invoiceDate | date:'MM/d/yyyy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="customerName">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                       Entity Name
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{element.customerName}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="lineItemSubtotal">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Amount
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{element.lineItemSubtotal | currency}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="invoiceRecipientCount">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Number of Parkers
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{element.invoiceRecipientCount}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="deliveryType">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Delivery
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{element.deliveryType}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Status
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        @if(element.isPrelim){
                            Prelim
                        }
                        @else
                        {
                            <span style="font-weight: bold;">Finalized</span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef style="width:150px;"> 
                        Type
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        @if(element.customerType == 'C'){
                            Company
                        }
                        @else
                        {
                            Parker
                        }
                    </td>
                </ng-container>
              
                <tr mat-header-row *matHeaderRowDef="displayedColumnsOrders"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsOrders;"></tr>
              
               
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="10">No data matching the filter "{{input.value}}"</td>
                </tr>
              </table>

            </mat-tab>
            <mat-tab label="Activity Log"> 
                <p style="font-weight: bold;font-size:18px;">Log</p><br />
              
                <ul *ngFor="let line of workflowLogVerbiage">
                    <li>{{line}}</li>
                </ul>
              
            </mat-tab>
            
            </mat-tab-group>
        </ng-container>
